import axios from 'axios'
import store from '@/store'

const urlPath = '/dps/billing'

export default {
  async list(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.get(`${apiUrl}${urlPath}/list`, {
        params: params
      })
      callback(resp.data)
    } catch (error) {
      console.log(error)
      errorCallback()
    }
  },
  async download(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.get(`${apiUrl}${urlPath}/download`, {
        params: params
      })
      callback(resp.data)
    } catch (error) {
      console.log(error)
      errorCallback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/billingService.js